module.exports = __webpack_public_path__ + "img/sucess03.bdcd010a.png";